











import { Vue, Component } from 'vue-property-decorator'
import { State, Mutation, Getter } from 'vuex-class'
import config from 'config'

import { ECallbackType } from '../services/CallbackService'

@Component({
  name: 'ShouldAcceptButton'
})
export default class ShouldAcceptButton extends Vue {
  @State(state => state.CONTENT.iframe) iframe!: boolean

  @Getter('CONTENT/getApiCountry') country!: string
  @Getter('API/getShouldAccept') shouldAccept!: boolean
  @Getter('API/getError') hasError!: boolean

  @Mutation('API/SET_SHOULD_ACCEPT') setShouldAccept!: (value: boolean) => void

  isLoading = false

  get isInnerHtml () {
    return config.content.innerHtml
  }

  async updateConsents () {
    this.isLoading = true
    /* eslint-disable @typescript-eslint/camelcase */
    await this.$store.dispatch('API/registerUserContent', {
      privacy_policy: true,
      terms_of_use: true,
      app_type: config.api.appType,
      country: this.country
    })
    Vue.prototype.$callback.call(ECallbackType.shouldExit)
    this.setShouldAccept(false)
    this.isLoading = false
  }
}
